<div class="add-user border-r-16 no-gutters" *transloco="let t">
  <div class="col">
    <div class="row no-gutters">
      <div class="col">
        <form (ngSubmit)="onSubmit()" #addUserForm="ngForm">
          <div class="form-group">
            <label for="firstName">{{ t('user/firstName') }}</label>
            <input
              name="firstName"
              [(ngModel)]="userToAdd.firstName"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': firstNameError !== null }"
              id="firstName"
              type="text"
              placeholder="{{ t('user/firstNamePlaceHolder') }}"
              required
            />
            <div class="invalid-feedback">
              {{ firstNameError }}
            </div>
          </div>
          <div class="form-group">
            <label for="lastName">{{ t('user/lastName') }}</label>
            <input
              name="lastName"
              [(ngModel)]="userToAdd.lastName"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': lastNameError !== null }"
              id="lastName"
              type="text"
              placeholder="{{ t('user/lastNamePlaceHolder') }}"
              required
            />
            <div class="invalid-feedback">
              {{ lastNameError }}
            </div>
          </div>
          <div class="form-group">
            <label for="email">{{ t('user/email') }}</label>
            <input
              name="email"
              [(ngModel)]="userToAdd.email"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': emailError !== null }"
              id="email"
              type="email"
              placeholder="{{ t('user/emailPlaceHolder') }}"
              required
            />
            <div class="invalid-feedback">
              {{ emailError }}
            </div>
          </div>
          <div class="form-group">
            <label for="selectedRole">{{ t('user/role') }}</label>
            <ng-select
              name="selectedRole"
              [(ngModel)]="userToAdd.selectedRole"
              (ngModelChange)="onRoleChange()"
              [items]="roleOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': setGroupsError !== null }"
              id="selectedRole"
              required
            ></ng-select>
            <div class="invalid-feedback">
              {{ setGroupsError }}
            </div>
          </div>
          <div class="form-group">
            <label for="password">{{ t('user/generatedPassword') }}</label>
            <input
              name="password"
              [(ngModel)]="userToAdd.password"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': passwordError !== null }"
              id="password"
              type="text"
              placeholder="{{ t('user/newPassword') }}"
              required
            />
            <div class="invalid-feedback">
              {{ passwordError }}
            </div>
          </div>

          <hr />

          <div class="col text-center d-flex justify-content-end">
            <button [routerLink]="links.userList()" class="btn btn-lg btn-outline-primary me-4">
              {{ t('child/cancel') }}
            </button>
            <button type="submit" class="btn btn-lg btn-primary" [disabled]="!addUserForm.form.valid || disabledButton">
              {{ t('user/add') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
